import * as React from "react";
import type { SVGProps } from "react";
const SquareIcon = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" fill="none" style={{
  userSelect: "none",
  flexShrink: 0
}} {...props}><path fill="currentColor" fillRule="evenodd" d="M3.25 3.25h17.5v17.5H3.25zm1.5 1.5v14.5h14.5V4.75z" clipRule="evenodd" /></svg>;
export default SquareIcon;